import React, { memo, useRef } from 'react';
import Box from '../Box';
const FormGroupContext = /*#__PURE__*/React.createContext();
const {
  Provider
} = FormGroupContext;
const FormGroup = /*#__PURE__*/memo(props => {
  const idRef = useRef("form-group-".concat(Math.floor(Math.random() * 10000000)));
  return /*#__PURE__*/React.createElement(Provider, {
    value: idRef.current
  }, /*#__PURE__*/React.createElement(Box, props));
});
FormGroup.propTypes = {};
FormGroup.defaultProps = {
  mb: 3
};
FormGroup.displayName = 'FormGroup';
export default FormGroup;
export { FormGroupContext };